import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=7980d104&scoped=true&"
import script from "./FormButtons.vue?vue&type=script&lang=ts&"
export * from "./FormButtons.vue?vue&type=script&lang=ts&"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=7980d104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980d104",
  null
  
)

export default component.exports